import Api, {
  baseURL,
  requestOptionsDELETE,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsPUT,
  requestOptionsPUTWithBody
} from '../api';
import newFetch from '../utils/newFetch';
import removeCaracters from '@/utils/removeCaracters';
import maskData from '@/utils/maskData';
import maskPrice from '@/utils/maskPrice';
import { UrlMaker } from '@/utils/urlParamsMaker';

const mapBackupRequest = ({ filters, selectedItems }) => {
  const body = {
    deliveryForecastDateStart: filters.initialForecastDate,
    deliveryForecastDateEnd: filters.endForecastDate,
    completionDateStart: filters.initialCompletionDate,
    completionDateEnd: filters.endCompletionDate,
    authorizationDateStart: filters.initialAuthDate,
    authorizationDateEnd: filters.endAuthDate,
    stateId: filters.stateId,
    cityId: filters.cityId,
    hasReceipt: filters.hasReceiptFilter,
    cteNumber: filters.numberCTE.map((number) => parseInt(number)),
    recipientName: filters.recipient,
    nfeNumber: filters.keyNfe,
    statusIds: filters.status,
    boardingNumber: filters.boardingNumber.map((number) => parseInt(number)),
    receiptIsValid: filters.isReceiptValidFilter,
    deliveryIds: selectedItems.filter((item) => item.type === 'Entrega').map((item) => item.id),
    nfeIds: selectedItems.filter((item) => item.type === 'Nfe').map((item) => item.id),
    numberInvoiceId: filters.numberInvoiceId
  };
  return body;
};

const mapShipperDelivery = (deliveries) => {
  return deliveries.map((delivery, index) => {
    return {
      key: index,
      data: {
        ...delivery,
        authorizationDate: maskData(delivery.authorizationDate),
        emissionDate: maskData(delivery.emissionDate),
        deliveryForecast: maskData(delivery.deliveryForecast),
        type: 'Entrega',
        actions: ''
      },
      children: [],
      type: 'DeliveryShipper',
      open: false,
      selected: false
    };
  });
};

const mapShipperNfe = (nfes) => {
  return nfes.map((nfe, index) => {
    return {
      key: index,
      data: {
        ...nfe,
        price: maskPrice(nfe.price),
        completionDate: nfe.completionDate ? maskData(nfe.completionDate) : '',
        type: 'Nfe',
        actions: ''
      },
      children: [],
      type: 'NfeShipper',
      open: false,
      selected: false
    };
  });
};
const mapShipperNfeFast = (nfes) => {
  return nfes.map((nfe, index) => {
    return {
      key: index,
      data: {
        ...nfe,
        price: maskPrice(nfe.price),
        completionDate: nfe.completionDate ? maskData(nfe.completionDate) : '',
        type: 'Nfe',
        actions: ''
      },
      children: [],
      type: 'NoHierarchy',
      open: false,
      selected: false
    };
  });
};

const mapGetShipper = (shipper) => {
  return {
    isPhysicalPerson: shipper.isPhysicalPerson,
    generalData: {
      email: shipper.email,
      personalName: shipper.name,
      socialReason: shipper.name,
      fantasyName: shipper.fantasyName,
      cnpj: shipper.senderCpfOrCnpjs.map((item) => item.cpfOrCnpj),
      cpf: shipper.senderCpfOrCnpjs.map((item) => item.cpfOrCnpj),
      celphone: shipper.phones.length ? shipper.phones[0] : '',
      phone: shipper.phones.length === 2 ? shipper.phones[1] : ''
    },
    addressData: {
      ...shipper.address
    }
  };
};

const getShipperDeliveryParams = (params, baseUrl) => {
  const {
    pageNumber,
    pageSize,
    recipient,
    initialCompletionDate,
    endCompletionDate,
    initialForecastDate,
    endForecastDate,
    initialAuthDate,
    endAuthDate,
    stateId,
    cityId,
    hasReceiptFilter,
    isReceiptValidFilter,
    numberCTE,
    keyNfe,
    boardingNumber,
    status,
    isReceiptDownloaded,
    isReceiptPurged,
    numberInvoiceId
  } = params;

  const urlMaker = UrlMaker(baseUrl);

  urlMaker.addKeyAndString('PageNumber', pageNumber);
  urlMaker.addKeyAndString('PageSize', pageSize);
  urlMaker.addKeyAndString('RecipientName', recipient);
  urlMaker.addKeyAndString('StateId', stateId);
  urlMaker.addKeyAndString('CityId', cityId);
  urlMaker.addKeyAndString('AuthorizationDateEnd', endAuthDate);
  urlMaker.addKeyAndString('AuthorizationDateStart', initialAuthDate);
  urlMaker.addKeyAndString('DeliveryForecastDateStart', initialForecastDate);
  urlMaker.addKeyAndString('DeliveryForecastDateEnd', endForecastDate);
  urlMaker.addKeyAndString('CompletionDateEnd', endCompletionDate);
  urlMaker.addKeyAndString('CompletionDateStart', initialCompletionDate);
  urlMaker.addKeyAndArray('NfeNumber', keyNfe);
  urlMaker.addKeyAndArray('CteNumber', numberCTE);
  urlMaker.addKeyAndArray('BoardingNumber', boardingNumber);
  urlMaker.addKeyAndArray('StatusIds', status);
  urlMaker.addKeyAndBoolean('DownloadedReceipt', isReceiptDownloaded);
  urlMaker.addKeyAndBoolean('PurgedReceipt', isReceiptPurged);
  urlMaker.addKeyAndBoolean('HasReceipt', hasReceiptFilter);
  urlMaker.addKeyAndBoolean('ReceiptIsValid', isReceiptValidFilter);
  urlMaker.addKeyAndBoolean('NumberInvoiceId', numberInvoiceId);

  return urlMaker.getURL();
};

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getShipperDeliveries(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getShipperDeliveryParams(params, Api.getShipperDeliveries),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data = mapShipperDelivery(res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getShipperNfes(_, params = { deliveryId: null }) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + `${Api.getShipperNfes}?deliveryId=${params.deliveryId}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(mapShipperNfe(data));
        })
        .catch((err) => reject(err));
    });
  },

  getShipperNfesFastManagement(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getShipperDeliveryParams(params, Api.getShipperNfesFastManagement),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data = mapShipperNfeFast(res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getShippers(_, params = { pageNumber: 1, pageSize: 10 }) {
    const { pageNumber, pageSize } = params;

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getShippers + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getShipper(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + `${Api.getShipper}/${id}`, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(mapGetShipper(data));
        })
        .catch((err) => reject(err));
    });
  },
  deleteShipper(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + `${Api.deleteShipper}/${id}`, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createShipper(_, body) {
    const { isCompany, addressData } = body;
    const hasAddress = !!addressData.cep;
    let payload = {};
    if (isCompany) {
      payload = {
        isPhysicalPerson: false,
        name: body.generalData.socialReason,
        fantasyName: body.generalData.fantasyName,
        senderCpfOrCnpjs: body.generalData.cnpj.map((cnpj) => ({
          cpfOrCnpj: cnpj
        })),
        phones: [...[body.generalData.celphone, body.generalData.phone].filter((value) => value)],
        ...(hasAddress ? { address: body.addressData } : null),
        email: body.generalData.email,
        password: body.accessData.password,
        confirmPassword: body.accessData.confirmPassword
      };
    } else {
      payload = {
        isPhysicalPerson: true,
        name: body.generalData.personalName,
        fantasyName: '',
        senderCpfOrCnpjs: body.generalData.cpf.map((cnpj) => ({
          cpfOrCnpj: cnpj
        })),
        phones: [...[body.generalData.celphone, body.generalData.phone].filter((value) => value)],
        ...(hasAddress ? { address: body.addressData } : null),
        email: body.generalData.email,
        password: body.accessData.password,
        confirmPassword: body.accessData.confirmPassword
      };
    }
    payload.phones = payload.phones.map((phone) => removeCaracters(phone));
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createShipper, requestOptionsPOST(localStorage.getItem('accessToken'), payload))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  editShipper(_, body) {
    const { isCompany, addressData } = body;
    const hasAddress = !!addressData.cep;
    let payload = {};
    if (isCompany) {
      payload = {
        id: body.id,
        isPhysicalPerson: false,
        name: body.generalData.socialReason,
        fantasyName: body.generalData.fantasyName,
        senderCpfOrCnpjs: body.generalData.cnpj.map((cnpj) => ({
          cpfOrCnpj: cnpj
        })),
        phones: [...[body.generalData.celphone, body.generalData.phone].filter((value) => value)],
        ...(hasAddress ? { address: body.addressData } : null),
        email: body.generalData.email,
        password: body.accessData.password,
        confirmPassword: body.accessData.confirmPassword
      };
    } else {
      payload = {
        id: body.id,
        isPhysicalPerson: true,
        name: body.generalData.personalName,
        fantasyName: '',
        senderCpfOrCnpjs: body.generalData.cpf.map((cnpj) => ({
          cpfOrCnpj: cnpj
        })),
        phones: [...[body.generalData.celphone, body.generalData.phone].filter((value) => value)],
        ...(hasAddress ? { address: body.addressData } : null),
        email: body.generalData.email,
        password: body.accessData.password,
        confirmPassword: body.accessData.confirmPassword
      };
    }
    payload.phones = payload.phones.map((phone) => removeCaracters(phone));
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.editShipper, requestOptionsPUTWithBody(localStorage.getItem('accessToken'), payload))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  enableShipper(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + `${Api.enableShipper}/${id}`, requestOptionsPUT(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  disableShipper(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + `${Api.disableShipper}/${id}`, requestOptionsPUT(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getBackupList() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getBackupList, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          data = data.map((item) => {
            return { ...item, nfeNumber: item.nfeNumber.split(',') };
          });
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getReceiptsPdfList() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getListDownloadReceiptPdf, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  async downloadBackup(_, backupId) {
    const base_url = baseURL + `${Api.downloadReceiptZip}/${backupId}`;
    const obj = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken').toString(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Response-Type': 'APPLICATION/octet-stream'
      },
      method: 'GET'
    };

    await fetch(base_url, obj)
      .then((response) => {
        if (response.status === 200) {
          return response.blob();
        } else {
          return Promise.reject(response);
        }
      })
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = `${backupId}.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  },
  async downloadReceiptPdf(_, id) {
    const obj = requestOptionsGET(localStorage.getItem('accessToken'));
    const URL = baseURL + (Api.downloadReceiptPdfFile + id);

    try {
      const response = await fetch(URL, obj);
      if (response.status === 200) {
        const blob = await response.blob();
        const fileName = response.headers.get('file-name');
        const fileURL = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { success: true };
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      console.log(error);
      console.error(error);
    }
  },
  uploadReceiptToBackup(_, params) {
    const body = mapBackupRequest(params);
    return new Promise((resolve, reject) => {
      newFetch(baseURL + `${Api.uploadReceiptsToBackup}`, requestOptionsPOST(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  downloadReceiptsByInvoice(_, invoiceId) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + (Api.downloadReceiptByInvoice + invoiceId),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  downloadReceiptPdfByInvoice(_, invoiceId) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + (Api.downloadReceiptPdf + invoiceId), requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
